"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_chartjs_2_1 = require("react-chartjs-2");
const chart_js_1 = require("chart.js");
chart_js_1.Chart.register(...chart_js_1.registerables);
const chartTypes = ["bar", "line", "pie", "doughnut", "polararea", "radar", "scatter", "bubble"];
function wrapType(str, length) {
    if (str.length > length) {
        let p = length;
        while (p > 0) {
            if (str.charAt(p) === " ") {
                // if a dash or space is found, wrap the string
                let left = str.substring(0, p);
                let right = str.substring(p + 1);
                return left + "\n" + wrapType(right, length); // return the wrapped string
            }
            p--;
        }
    }
    return str; // return the original string
}
const Charts = ({ data, chartType, chartTitle, options = {
    plugins: {
        legend: {
            display: false,
        },
        title: {
            display: true,
            text: "",
            padding: {
                top: 10,
                bottom: 30,
            },
        },
    },
}, }) => {
    let activeOptions = options;
    activeOptions.plugins.title.text = chartTitle;
    activeOptions.plugins.tooltip = {
        callbacks: {
            title: (context) => {
                const stringArray = wrapType(context[0].label, 35).split("\n");
                stringArray.push(": " + context[0].raw.toString());
                return stringArray;
            },
            label: () => "",
        },
    };
    activeOptions.scales = {
        x: {
            ticks: {
                callback: function (val) {
                    return this.getLabelForValue(val).substring(0, 20);
                },
            },
        },
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("section", { className: "flex h-full w-full flex-col items-center justify-center" },
            react_1.default.createElement("div", { className: chartType == chartTypes[3] || chartType == chartTypes[2]
                    ? "flex h-[80%] w-[65%] flex-col items-center justify-start"
                    : "flex h-[80%] w-[90%] flex-col items-center justify-start" },
                chartType == chartTypes[0] && react_1.default.createElement(react_chartjs_2_1.Bar, { datasetIdKey: "id", data: data, options: activeOptions }),
                chartType == chartTypes[1] && react_1.default.createElement(react_chartjs_2_1.Line, { datasetIdKey: "id", data: data, options: activeOptions }),
                chartType == chartTypes[2] && react_1.default.createElement(react_chartjs_2_1.Pie, { datasetIdKey: "id", data: data, options: activeOptions }),
                chartType == chartTypes[3] && react_1.default.createElement(react_chartjs_2_1.Doughnut, { datasetIdKey: "id", data: data, options: activeOptions }),
                chartType == chartTypes[4] && (react_1.default.createElement(react_chartjs_2_1.PolarArea, { datasetIdKey: "id", data: data, options: activeOptions })),
                chartType == chartTypes[5] && (react_1.default.createElement(react_chartjs_2_1.Radar, { datasetIdKey: "id", data: data, options: activeOptions })),
                chartType == chartTypes[6] && react_1.default.createElement(react_chartjs_2_1.Scatter, { datasetIdKey: "id", data: data, options: activeOptions }),
                chartType == chartTypes[7] && react_1.default.createElement(react_chartjs_2_1.Bubble, { datasetIdKey: "id", data: data, options: activeOptions })))));
};
exports.default = Charts;
